import { AuthProvider } from "@refinedev/core";
import Keycloak from "keycloak-js";
import { config } from "../config/config";
import i18n from "../utils/i18n";
import { addTokenRefreshInterceptors, setAxiosLanguage } from "../utils/axios";

type KeycloakProviderCreator = (_keycloak: Keycloak) => AuthProvider;

export type KeycloakIdentity = {
  name: string;
  surname: string;
  sellerId?: string;
};

export const keycloakConfig = new Keycloak({
  clientId: config.KC_CLIENT_ID,
  url: config.KC_HOST,
  realm: config.KC_REALM,
});

export const createKeycloakProvider: KeycloakProviderCreator = (
  keycloak: Keycloak,
) => {
  addTokenRefreshInterceptors(keycloak);

  return {
    login: async () => {
      const currentLanguage = i18n.language;

      // Trigger the Keycloak login with the desired language
      await keycloak.login({
        redirectUri: window.location.origin,
        locale: currentLanguage, // Set the language parameter
      });

      return {
        success: true,
      };
    },
    logout: async () => {
      try {
        await keycloak.logout();

        return {
          success: true,
        };
      } catch {
        return {
          success: false,
          error: new Error("Logout failed"),
        };
      }
    },
    onError: async (error) => {
      return { error };
    },
    check: async () => {
      const { token } = keycloak;

      if (token) {
        setAxiosLanguage(i18n.language);

        return {
          authenticated: true,
        };
      }

      return {
        authenticated: false,
        logout: true,
        redirectTo: "/login",
        error: {
          message: "Check failed",
          name: "Token not found",
        },
      };
    },
    getPermissions: async () => null,
    getIdentity: async (): Promise<KeycloakIdentity | null> => {
      if (keycloak?.tokenParsed) {
        return {
          name: keycloak.tokenParsed.given_name,
          surname: keycloak.tokenParsed.family_name,
          sellerId: keycloak.tokenParsed.sellerId,
        };
      }
      return null;
    },
  };
};
